/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
export const EnumValue = core.serialization.undiscriminatedUnion([
    core.serialization.string(),
    core.serialization.number(),
    core.serialization.boolean(),
]);
